import { useCallback, useRef, useState } from "react";
import QRCode from "react-qr-code";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import { Tooltip } from "@material-ui/core";
import Toast from "../../Toast/Toast";
import checkIcon from "../../Toast/Image/check.svg";
import LogoQrCode from "../Images/logo-qr-code.svg";
import { Container } from "./styles";
import html2canvas from "html2canvas";

type Props = {
  open: boolean;
  onClose: () => void;
  link: string;
  nome: string;
  razaoSocial: string;
};

export function ModalCopy({ open, onClose, link, nome, razaoSocial }: Props) {
  const [title, setTitle] = useState<string>("Copiar link");
  const [list, setList] = useState<unknown[]>([]);
  const qrRef = useRef<HTMLDivElement>(null);

  let toastProperties: unknown = null;
  const showToast = useCallback(
    (type) => {
      const id = Math.floor(Math.random() * 101 + 1);

      switch (type) {
        case "copied":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Link copiado para área de transferência!",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        case "downloaded":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Imagem do QR Code baixada com sucesso!",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [toastProperties]
  );

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "760px",
      width: "90%",
    },
  };

  async function copy() {
    try {
      await navigator.clipboard.writeText(link);
      setTitle("Copiado");
      showToast("copied");

      setTimeout(() => {
        setTitle("Copiar link");
      }, 1000);
    } catch (err) {
      console.error("Falha ao copiar o link: ", err);
    }
  }

  const downloadQRCode = async () => {
    const qrCodeElement = qrRef.current?.querySelector("svg");
    if (qrCodeElement) {
      const svgString = new XMLSerializer().serializeToString(qrCodeElement);
      const qrImageSrc = `data:image/svg+xml;base64,${window.btoa(svgString)}`;
      const htmlString = `
      <div style="width: 425px; height: 859px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: linear-gradient(180deg, #6C5AF4 54.17%, rgba(108, 90, 244, 0.75) 100%), linear-gradient(0deg, #FFFFFF, #FFFFFF); text-align: center; padding: 20px; position: relative;">
    <img src="${LogoQrCode}" style="width: 150px; margin-top: 20px; position: absolute; top:${
        nome.length >= 29 ? "20%" : "23%"
      } ; transform: translateY(-50%);" />
    <div style="min-height:478px; width: 363px; display: flex;  background: #fff; margin-top: 50px; padding: 50px; flex-direction: column; justify-content: center; align-items: center; gap: 1.5rem; border-radius: 8px;">
        <div>
            <h2 style="color: black; font-family: Open Sans; font-size: 24px; font-weight: 700;">${nome}</h2>
            <h3 style="color: black; font-size: 16px; font-family: Open Sans;">${razaoSocial}</h3>
        </div>
        <img src="${qrImageSrc}" width="250" height="250" />
    </div>
    <p style="font-family: Open Sans; color: #ffffff; position: absolute; bottom: 88px; width: 100%;">
        Escaneie o QR Code com sua câmera<br/> para acessar o link.
    </p>
</div>
        `;
      const tempElement = document.createElement("div");
      tempElement.style.position = "absolute";
      tempElement.style.top = "-9999px";
      tempElement.style.left = "-9999px";
      tempElement.innerHTML = htmlString;
      document.body.appendChild(tempElement);
      const container = tempElement.firstElementChild as HTMLElement;
      if (container) {
        await new Promise<void>((resolve) => {
          const images = container.querySelectorAll("img");
          let loadedImages = 0;
          images.forEach((img) => {
            img.onload = () => {
              loadedImages++;
              if (loadedImages === images.length) {
                resolve();
              }
            };
            img.onerror = () => {
              loadedImages++;
              if (loadedImages === images.length) {
                resolve();
              }
            };
          });
        });

        const canvas = await html2canvas(container);
        const qrImageURL = canvas.toDataURL("image/png");
        const downloadLink = document.createElement("a");
        downloadLink.href = qrImageURL;
        downloadLink.download = "Link de vendas - QR Code.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        document.body.removeChild(tempElement);
        showToast("downloaded");
      } else {
        document.body.removeChild(tempElement);
      }
    }
  };

  return (
    <>
      <Toast toastList={list} autoDelete={true} />

      <Modal
        isOpen={open}
        onRequestClose={onClose}
        contentLabel="Modal"
        ariaHideApp={false}
        style={customStyles}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close",
        }}
        shouldCloseOnOverlayClick={true}
      >
        <Container>
          <Button
            className="close-button"
            onClick={onClose}
            sx={{ position: "absolute", top: 8, right: 8, color: "black" }}
          >
            <CloseIcon />
          </Button>

          <h1>Enviar meu link</h1>
          <div style={{ display: "flex" }}>
            <input className="input-link" type="text" value={link} />
            <Tooltip title={title} placement="top" arrow>
              <button className="copy-button" type="button" onClick={copy}>
                Copiar link
              </button>
            </Tooltip>
          </div>
          <span>
            Escaneie o QR Code com a câmera ou baixe a imagem dele clicando no
            botão abaixo.
          </span>
          <div ref={qrRef}>
            <QRCode value={link} />
          </div>
          <button
            className="download-button"
            type="button"
            onClick={downloadQRCode}
          >
            Baixar
          </button>
        </Container>
      </Modal>
    </>
  );
}
